import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useContext } from "react";
import PublicRoutes from "./PublicRoutes";
import ProtectedRoutes from "./ProtectedRoutes";
import { UserContext } from "../context/UserContext";
import { FoodServiceProvider } from "../context/FoodServiceContext";
import { EntitlementsProvider } from "../context/EntitlementsContext";

// Wrapper برای مسیرهای Protected با FoodServiceProvider
const ProtectedWithFoodService = ({ children }) => {
  const { user, loading } = useContext(UserContext);

  if (loading) return <div>در حال بارگذاری...</div>;

  if (!user) return <Navigate to="/auth/restaurant" replace />;

  return (
    <FoodServiceProvider restaurantId={user._id}>
      <EntitlementsProvider>{children}</EntitlementsProvider>
    </FoodServiceProvider>
  );
};


const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* مسیرهای Protected */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedWithFoodService>
              <ProtectedRoutes />
            </ProtectedWithFoodService>
          }
        />

        {/* مسیرهای عمومی */}
        <Route path="/*" element={<PublicRoutes />} />

        {/* صفحه 404 */}
        <Route path="*" element={<h1>صفحه پیدا نشد 😕</h1>} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
